<template>
    <div class="uk-width-1-1 uk-align-center multi-channel-schedule-grid multi-schedule-main-div" style="width: 95%">
        <div :class="mode" aria-labelledby="schedule-heading" style="margin-left: 125px;">
            <div :id="`modal-full-${_id}`" :class="`modal-full-${_id}`" style="z-index: 100000;" uk-modal>
                <div v-if="selected_air_data != null" class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical" style="padding-top: 30px;z-index: 2100;min-width: 906px;padding-right:0;">
                    <button @click="selected_air_data = null" class="uk-modal-close-full" style="background:transparent;position: absolute;float: right;margin-right: -20px;margin-top: -18px;border: 0;padding: 0;height: 50px;width: 50px;border-radius: unset;">
<!--                        <img src="/images/schedule/toggle-close-x.svg" style="height: 50px;width: 50px;background:white;border-radius: 50px;"/>-->
                      <div class="x-button" style="background-image: url(/images/schedule/toggle-close.svg); width: 40px; height: 40px; margin-top: -10px; background-color: white; border-right: 10000px; border: 2px solid white;"></div>
                    </button>
                    <div class="uk-grid-collapse uk-child-width-1-2@s uk-flex-top uk-grid" style="" uk-grid="">
                        <div style="width: 100%;padding-right:30px;">
                          <div style="float:right;max-width: 170px;min-width: 170px;margin-top:25px;">
                              <a class="button-schedule button-watch-now uk-hidden@xs uk-visible@m" v-if="selected_air_data.program_details.display_option == 9
                                && selected_air_data.program_details.media_manager_data.passport != null
                                && selected_air_data.program_details.media_manager_data.passport != undefined" target="_blank"
                               :href="`https://video.pbs12.org/video/${selected_air_data.program_details.media_manager_data.passport.asset_slug}/`">watch now</a>
                            <a class="button-schedule button-watch-now uk-hidden@xs uk-visible@m" v-else-if="selected_air_data.program_details.display_option == 9
                                && selected_air_data.program_details.media_manager_data.public != null
                                && selected_air_data.program_details.media_manager_data.public != undefined" target="_blank"
                               :href="`https://video.pbs12.org/video/${selected_air_data.program_details.media_manager_data.public.asset_slug}/`">watch now</a>
                          </div>
                            <span style="margin-left: 10px;font-weight: bold;">{{selected_air_data.text_formatted_date}} at {{selected_air_data.show_time}} on {{channel}}</span>
                            <br />
                            <span style="margin-left: 10px;" class="pbs-schedule-grid-title">{{selected_air_data.series_title}}</span>
                            <br />
                            <span style="margin-left: 10px;"  class="pbs-schedule-grid-sub-title" v-if="selected_air_data.episode_title.length > 0 && selected_air_data.series_title !== selected_air_data.episode_title">{{selected_air_data.episode_title}}</span>
                            <br v-if="selected_air_data.program_details.episode_desc.trim().length > 1 ||selected_air_data.program_details.series_desc.trim().length > 1"/>
                            <br v-if="selected_air_data.program_details.episode_desc.trim().length > 1 ||selected_air_data.program_details.series_desc.trim().length > 1"/>
                            <ProgramDetails v-bind:air_data="selected_air_data" />
                        </div>
                    </div>
                </div>
            </div>
            <!--
            <span class="track-slot track-1-title" aria-hidden="true" style="grid-column: track-1; grid-row: tracks;margin-right: auto;margin-left: auto;z-index: 500; background-color: rgba(255,255,255,1); height: 75px; padding: 10px;"><img src="https://entry-express.com/_design/pbs/channel-121-pbs12.svg" width="180"></span>
            <span class="track-slot track-2-title" aria-hidden="true" style="grid-column: track-2; grid-row: tracks;margin-right: auto;margin-left: auto;z-index: 500; background-color: rgba(255,255,255,1); height: 75px; padding: 10px;"><img src="https://entry-express.com/_design/pbs/channel-122-fnx.svg" width="180"></span>
            <span class="track-slot track-3-title" aria-hidden="true" style="grid-column: track-3; grid-row: tracks;margin-right: auto;margin-left: auto;z-index: 500; background-color: rgba(255,255,255,1); height: 75px; padding: 10px;"><img src="https://entry-express.com/_design/pbs/channel-123-dw.svg" width="180"></span>
            <span class="track-slot track-4-title" aria-hidden="true" style="grid-column: track-4; grid-row: tracks;margin-right: auto;margin-left: auto;z-index: 500; background-color: rgba(255,255,255,1); height: 75px; padding: 10px;"><img src="https://entry-express.com/_design/pbs/channel-124-nhk.svg" width="180"></span>
            <br />
            <br />
            <br />
            <br /-->

            <h2 v-if="mode == 'schedule' || mode == 'early_morning'" class="time-slot mutichannel-time" style="grid-row: time-0000;">12:00 am</h2>
            <h2 v-if="mode == 'schedule' || mode == 'early_morning'" class="time-slot" style="grid-row: time-0030;">12:30 am</h2>
            <h2 v-if="mode == 'schedule' || mode == 'early_morning'" class="time-slot" style="grid-row: time-0100;">1:00 am</h2>
            <h2 v-if="mode == 'schedule' || mode == 'early_morning'" class="time-slot" style="grid-row: time-0130;">1:30 am</h2>
            <h2 v-if="mode == 'schedule' || mode == 'early_morning'" class="time-slot" style="grid-row: time-0200;">2:00 am</h2>
            <h2 v-if="mode == 'schedule' || mode == 'early_morning'" class="time-slot" style="grid-row: time-0230;">2:30 am</h2>
            <h2 v-if="mode == 'schedule' || mode == 'early_morning'" class="time-slot" style="grid-row: time-0300;">3:00 am</h2>
            <h2 v-if="mode == 'schedule' || mode == 'early_morning'" class="time-slot" style="grid-row: time-0330;">3:30 am</h2>
            <h2 v-if="mode == 'schedule' || mode == 'early_morning'" class="time-slot" style="grid-row: time-0400;">4:00 am</h2>
            <h2 v-if="mode == 'schedule' || mode == 'early_morning'" class="time-slot" style="grid-row: time-0430;">4:30 am</h2>
            <h2 v-if="mode == 'schedule' || mode == 'early_morning'" class="time-slot" style="grid-row: time-0500;">5:00 am</h2>
            <h2 v-if="mode == 'schedule' || mode == 'early_morning'" class="time-slot" style="grid-row: time-0530;">5:30 am</h2>
            <h2 v-if="mode == 'schedule' || mode == 'early_morning' || mode == 'morning'" class="time-slot" style="grid-row: time-0600;">6:00 am</h2>
            <h2 v-if="mode == 'schedule' || mode == 'morning'" class="time-slot" style="grid-row: time-0630;">6:30 am</h2>
            <h2 v-if="mode == 'schedule' || mode == 'morning'" class="time-slot" style="grid-row: time-0700;">7:00 am</h2>
            <h2 v-if="mode == 'schedule' || mode == 'morning'" class="time-slot" style="grid-row: time-0730;">7:30 am</h2>
            <h2 v-if="mode == 'schedule' || mode == 'morning'" class="time-slot" style="grid-row: time-0800;">8:00 am</h2>
            <h2 v-if="mode == 'schedule' || mode == 'morning'" class="time-slot" style="grid-row: time-0830;">8:30 am</h2>
            <h2 v-if="mode == 'schedule' || mode == 'morning'" class="time-slot" style="grid-row: time-0900;">9:00 am</h2>
            <h2 v-if="mode == 'schedule' || mode == 'morning'" class="time-slot" style="grid-row: time-1000;">10:00 am</h2>
            <h2 v-if="mode == 'schedule' || mode == 'morning'" class="time-slot" style="grid-row: time-1030;">10:30 am</h2>
            <h2 v-if="mode == 'schedule' || mode == 'morning'" class="time-slot" style="grid-row: time-1100;">11:00 am</h2>
            <h2 v-if="mode == 'schedule' || mode == 'morning'" class="time-slot" style="grid-row: time-1130;">11:30 am</h2>
            <h2 v-if="mode == 'schedule' || mode == 'morning' || mode == 'afternoon'" class="time-slot" style="grid-row: time-1200;">12:00 pm</h2>
            <h2 v-if="mode == 'schedule' || mode == 'afternoon' " class="time-slot" style="grid-row: time-1230;">12:00 pm</h2>
            <h2 v-if="mode == 'schedule' || mode == 'afternoon'" class="time-slot" style="grid-row: time-1300;">1:00 pm</h2>
            <h2 v-if="mode == 'schedule' || mode == 'afternoon'" class="time-slot" style="grid-row: time-1330;">1:30 pm</h2>
            <h2 v-if="mode == 'schedule' || mode == 'afternoon'" class="time-slot" style="grid-row: time-1400;">2:00 pm</h2>
            <h2 v-if="mode == 'schedule' || mode == 'afternoon'" class="time-slot" style="grid-row: time-1430;">2:30 pm</h2>
            <h2 v-if="mode == 'schedule' || mode == 'afternoon'" class="time-slot" style="grid-row: time-1500;">3:00 pm</h2>
            <h2 v-if="mode == 'schedule' || mode == 'afternoon'" class="time-slot" style="grid-row: time-1530;">3:30 pm</h2>
            <h2 v-if="mode == 'schedule' || mode == 'afternoon'" class="time-slot" style="grid-row: time-1600;">4:00 pm</h2>
            <h2 v-if="mode == 'schedule' || mode == 'afternoon'" class="time-slot" style="grid-row: time-1630;">4:30 pm</h2>
            <h2 v-if="mode == 'schedule' || mode == 'afternoon'" class="time-slot" style="grid-row: time-1700;">5:00 pm</h2>
            <h2 v-if="mode == 'schedule' || mode == 'afternoon'" class="time-slot" style="grid-row: time-1730;">5:30 pm</h2>
            <h2 v-if="mode == 'schedule' || mode == 'afternoon'" class="time-slot" style="grid-row: time-1800;">6:00 pm</h2>
            <h2 v-if="mode == 'schedule'" class="time-slot" style="grid-row: time-1830;">6:30 pm</h2>
            <h2 v-if="mode == 'schedule' || mode == 'evening'" class="time-slot" style="grid-row: time-1900;">7:00 pm</h2>
            <h2 v-if="mode == 'schedule' || mode == 'evening'" class="time-slot" style="grid-row: time-1930;">7:30 pm</h2>
            <h2 v-if="mode == 'schedule' || mode == 'evening'" class="time-slot" style="grid-row: time-2000;">8:00 pm</h2>
            <h2 v-if="mode == 'schedule' || mode == 'evening'" class="time-slot" style="grid-row: time-2030;">8:30 pm</h2>
            <h2 v-if="mode == 'schedule' || mode == 'evening'" class="time-slot" style="grid-row: time-2100;">9:00 pm</h2>
            <h2 v-if="mode == 'schedule' || mode == 'evening'" class="time-slot" style="grid-row: time-2130;">9:30 pm</h2>
            <h2 v-if="mode == 'schedule' || mode == 'evening'" class="time-slot" style="grid-row: time-2200;">10:00 pm</h2>
            <h2 v-if="mode == 'schedule' || mode == 'evening'" class="time-slot" style="grid-row: time-2230;">10:30 pm</h2>
            <h2 v-if="mode == 'schedule'" class="time-slot" style="grid-row: time-2300;">11:00 pm</h2>
            <h2 v-if="mode == 'schedule'" class="time-slot" style="grid-row: time-2330;">11:30 pm</h2>
            <h2 v-if="mode == 'schedule'" class="time-slot" style="grid-row: time-2400;">12:00 am</h2>

          <div v-if="mode !== 'evening'" class="session track-1" style="grid-area: time-0000 / track-1 / time-2400 / track-1; min-height: 30px; border-top: 2px solid rgb(119, 119, 119);"></div>
          <div v-if="mode !== 'evening'" class="session track-2" style="grid-area: time-0000 / track-2 / time-2400 / track-2; min-height: 30px; border-top: 2px solid rgb(119, 119, 119);"></div>
          <div v-if="mode !== 'evening'" class="session track-3" style="grid-area: time-0000 / track-3 / time-2400 / track-3; min-height: 30px; border-top: 2px solid rgb(119, 119, 119);"></div>
          <div v-if="mode !== 'evening'" class="session track-4" style="grid-area: time-0000 / track-4 / time-2400 / track-4; min-height: 30px; border-top: 2px solid rgb(119, 119, 119);"></div>

          <div v-if="mode === 'evening'" class="session track-1" style="grid-area: time-1900 / track-1 / time-2400 / track-1; min-height: 30px; border-top: 2px solid rgb(119, 119, 119);"></div>
          <div v-if="mode === 'evening'" class="session track-2" style="grid-area: time-1900 / track-2 / time-2400 / track-2; min-height: 30px; border-top: 2px solid rgb(119, 119, 119);"></div>
          <div v-if="mode === 'evening'" class="session track-3" style="grid-area: time-1900 / track-3 / time-2400 / track-3; min-height: 30px; border-top: 2px solid rgb(119, 119, 119);"></div>
          <div v-if="mode === 'evening'" class="session track-4" style="grid-area: time-1900 / track-4 / time-2400 / track-4; min-height: 30px; border-top: 2px solid rgb(119, 119, 119);"></div>

          <!--
            <div uk-toggle="target: #modal-full"
               :style="`${(calc_css_time(air_data) === '') ? 'display: none;':''} grid-column: track-1; grid-row: ${calc_css_time(air_data)};${(!air_data.program_details.episode_len.match(/^00:0/))? 'min-height: 30px;':'margin-top: 0px;'};
                          ${(n == 0)?'border-top: 2px solid #777;':''}
                          ${(calc_css_time(air_data).match(/time-2400/))?'border-bottom: 2px solid #777;':''}`">
            </div -->
            <div :uk-toggle="`target: #modal-full-${_id}`" @click="show_details(air_data, '12.1')" v-for="(air_data, n) in schedule_data['1']"
                 v-bind:key="air_data.fulldate+air_data.access_id"
                 :class="`session track-1${(air_data.now_playing)?' schedule-now-playing-multi':''}`"
                 :style="`${(calc_css_time(air_data) === '') ? 'display: none;':''} grid-column: track-1; grid-row: ${calc_css_time(air_data)};${(!air_data.program_details.episode_len.match(/^00:0/))? 'min-height: 30px;':'margin-top: 0px;'};
                          ${(n == 0)?'border-top: 2px solid #777;':''}
                          ${(calc_css_time(air_data).match(/time-2400/))?'border-bottom: 2px solid #777;':''}`">
                <div :id="`${(air_data.now_playing)?'schedule-now-playing-multi':''}`" class="show_details_content" :style="(air_data.program_details.episode_len.match(/^00:0/))?'margin-top: 2px;padding-top: 0px;':''">
                    <!--
                    {{air_data.show_time}}
                    <br v-if="!air_data.program_details.episode_len.match(/^00:0/)" />
                    -->
                    <strong></strong>
                      {{ trim_series_title(air_data.program_details) }}

                    <br />
                    <span class="multichannel-subtitle" v-if="air_data.episode_title.length > 0 && air_data.series_title !== air_data.episode_title">{{trim_episode_title(air_data.program_details)}}</span>
                </div>
            </div>
            <div :uk-toggle="`target: #modal-full-${_id}`" @click="show_details(air_data, '12.2')"  v-for="(air_data,n) in schedule_data['2']" v-bind:key="air_data.fulldate+air_data.access_id"
                 :class="`session track-2${(air_data.now_playing)?' schedule-now-playing-multi':''}`" :style="`${(calc_css_time(air_data) === '') ? 'display: none;':''}grid-column: track-2; grid-row: ${calc_css_time(air_data)};${(!air_data.program_details.episode_len.match(/^00:0/))? 'min-height: 30px;':'margin-top: 0px;'};${(n == 0)?'border-top: 2px solid #777;':''}${(calc_css_time(air_data).match(/time-2400/))?'border-bottom: 2px solid #777;':''}`">
                <div class="show_details_content" :style="(air_data.program_details.episode_len.match(/^00:0/))?'margin-top: 2px;padding-top: 0px;':''">
                  <!--
                  {{air_data.show_time}}
                  <br v-if="!air_data.program_details.episode_len.match(/^00:0/)" />
                  -->
                  <strong></strong>
                    {{ trim_series_title(air_data.program_details) }}
                    <br />
                    <span class="multichannel-subtitle" v-if="air_data.episode_title.length > 0 && air_data.series_title !== air_data.episode_title">{{trim_episode_title(air_data.program_details)}}</span>
                </div>
            </div>
            <div :uk-toggle="`target: #modal-full-${_id}`" @click="show_details(air_data, '12.3')" v-for="(air_data,n) in schedule_data['3']" v-bind:key="air_data.fulldate+air_data.access_id"
                 :class="`session track-3${(air_data.now_playing)?' schedule-now-playing-multi':''}`" :style="`${(calc_css_time(air_data) === '') ? 'display: none;':''}grid-column: track-3; grid-row: ${calc_css_time(air_data)};${(!air_data.program_details.episode_len.match(/^00:0/))? 'min-height: 30px;':'margin-top: 0px;'};${(n == 0)?'border-top: 2px solid #777;':''}${(calc_css_time(air_data).match(/time-2400/))?'border-bottom: 2px solid #777;':''}`">
                <div class="show_details_content" :style="(air_data.program_details.episode_len.match(/^00:0/))?'margin-top: 2px;padding-top: 0px;':''">
                  <!--
                  {{air_data.show_time}}
                  <br v-if="!air_data.program_details.episode_len.match(/^00:0/)" />
                  -->
                  <strong></strong>
                    {{ trim_series_title(air_data.program_details) }}
                    <br />
                    <span class="multichannel-subtitle" v-if="air_data.episode_title.length > 0 && air_data.series_title !== air_data.episode_title">{{trim_episode_title(air_data.program_details)}}</span>
                </div>
            </div>
            <div :uk-toggle="`target: #modal-full-${_id}`" @click="show_details(air_data, '12.4')"
                 v-for="(air_data,n) in schedule_data['4']" v-bind:key="air_data.fulldate+air_data.access_id"
                 :class="`session track-4${(air_data.now_playing)?' schedule-now-playing-multi':''}`" :style="`${(calc_css_time(air_data) === '') ? 'display: none;':''}grid-column: track-4; grid-row: ${calc_css_time(air_data)};${(!air_data.program_details.episode_len.match(/^00:0/))? 'min-height: 30px;':'margin-top: 0px;'};${(n == 0)?'border-top: 2px solid #777;':''}${(calc_css_time(air_data).match(/time-2400/))?'border-bottom: 2px solid #777;':''}`">
                <div class="show_details_content" :style="(air_data.program_details.episode_len.match(/^00:0/))?'margin-top: 2px;padding-top: 0px;':''">
                  <!--
                  {{air_data.show_time}}
                  <br v-if="!air_data.program_details.episode_len.match(/^00:0/)" />
                  -->
                  <strong></strong>
                    {{ trim_series_title(air_data.program_details) }}
                    <br />
                    <span class="multichannel-subtitle" v-if="air_data.episode_title.length > 0 && air_data.series_title !== air_data.episode_title">{{trim_episode_title(air_data.program_details)}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProgramDetails from "./ProgramDetails";
import $ from "jquery";

export default {
    components: {ProgramDetails},
    props:['schedule_data','current_day','mode','_id'],
    name: "MultiChannelSchedule",
    data(){
      return {
          base_url: 'https://www.pbs12.org/',
          selected_air_data: null
      }
    },
    methods:{
        trim_episode_title(program_details){
         //trim_episode_title(air_data.program_details)
          //The 77 Percent: The Magazine for Africa's
          let three_dots = (program_details.episode_title.length > 40)?" ...":""

          if(parseInt(program_details.total_mins) <= 20) return program_details.episode_title.substring(0, 40)+three_dots
          if(parseInt(program_details.total_mins) <= 30) return program_details.episode_title.substring(0, 40)+three_dots
          return program_details.episode_title
        },
        trim_series_title(program_details){
          //trim_episode_title(air_data.program_details)
          let three_dots = (program_details.series_title.length > 35)?" ...":""
          if(parseInt(program_details.total_mins) <= 20) return program_details.series_title.substring(0, 35)+three_dots
          if(parseInt(program_details.total_mins) <= 30) return program_details.series_title.substring(0, 35)+three_dots
          return program_details.series_title
        },
        format_date(fulldate){
            const event = new Date(Date.parse(fulldate))
            const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
            console.log(event.toLocaleDateString('en-US', options))
            return event.toLocaleDateString('en-US', options)
        },
        show_details(data, channel){
            this.selected_air_data = data
            this.channel = channel
            setTimeout(() => {
                let _class = '.multi-channel-schedule-grid'
                let multiplier = .17
                let height = $(_class).width() * .46
                if ($(_class).width() > 900) height = $(_class).width() * multiplier
                //console.log('program details width: '+_class, height)
                $('.pbs_media_manager_iframe').height(height)
                $('.pbs_media_manager_iframe').css('margin-bottom', '20px')
            }, 500)
        },
        details_description(program_details){
            if(program_details.episode_desc.length > 1 &&  program_details.episode_desc !== program_details.series_desc) return program_details.episode_desc
            return program_details.series_desc
        },
        calc_css_time(air_data){

            let time = air_data.program_details.start_time
            let hour_start = parseInt(time.split(/:/)[0])
            let hour_end = parseInt(air_data.program_details.end_time.split(/:/)[0])

            if(this.current_day.getDate()+1 !== parseInt(air_data.program_details.fulldate.split(/ /)[0].split(/-/)[2])) hour_start = 24
            if(this.current_day.getDate()+1 === parseInt(air_data.program_details.fulldate.split(/ /)[0].split(/-/)[2]) && hour_start > 0  && hour_end === 0) hour_end = 24

            let css_start_min = Math.ceil(parseInt(time.split(/:/)[1])/5)*5
            if(css_start_min === 60) css_start_min = 55
            //if(css_start_min < 10) css_start_min = `0${css_start_min}`
            if(css_start_min < 10) css_start_min = `00`
            if(css_start_min >= 10 && css_start_min < 15) css_start_min = `15`
            let css_start_hour = time.split(/:/)[0]
            //if(hour_start === 24 && css_start_hour === '00') css_start_hour = 24

            if(css_start_min === '05') css_start_min = '10'

            let css_start = `time-${css_start_hour}${css_start_min}`
            let duration_min = parseInt(Math.ceil(parseInt(air_data.program_details.end_time.split(/:/)[1])/5)*5)
            if(duration_min === 60) duration_min = 55

            if(hour_end > 25) hour_end = 25
            if(hour_start > 20 && hour_end == 0) hour_end = 24
            if(hour_end < 10) hour_end = `0${hour_end}`

            if(duration_min >= 10 && duration_min < 15) duration_min = `15`

            if(duration_min < 6) duration_min = 0
            if(duration_min < 10) duration_min = `0${duration_min}`

            if(duration_min == 30 && `${hour_end}${duration_min}` === `${css_start_hour}${css_start_min}`){
                hour_end = parseInt(hour_end)+1
                if(hour_end < 10) hour_end = `0${hour_end}`
                duration_min = '00'
            }
            //if(hour_end < 10) hour_end = `00`

            if(`${css_start_hour}` === '00'  && `${hour_end}` === '24') hour_end = `00`

            let css_end = `time-${hour_end}${duration_min}`

            //if(css_start_min == 15 && (parseInt(`${hour_end}${duration_min}`) - parseInt(`${css_start_hour}${css_start_min}`)) > 25) css_start = `time-${css_start_hour}20`

            // return nothing if the start == end
            if(css_start === css_end) return ''
            //console.log('returning this css:',`${css_start} / ${css_end} ${air_data.program_details.episode_len} / ${air_data.program_details.series_title} / ${air_data.program_details.fulldate} / duration_min:${duration_min} (${air_data.program_details.start_time}/${air_data.program_details.end_time})`)
            return `${css_start} / ${css_end}`
            //let len = air_data.program_details.fulldate.episode_len
        },
        hmsToSecondsOnly: (str) => {
            let p = str.split(':'),
                s = 0, m = 1;

            while (p.length > 0) {
                s += m * parseInt(p.pop(), 10);
                m *= 60
            }
            return s
        },
    }
}
</script>

<style scoped>

.schedule-now-playing-multi{
  background-color: #f8f5ec;
}
@media screen and (min-width:700px) {
    .early_morning {
            display: grid;
            /*grid-gap: 1em;*/
            grid-template-rows:
        [tracks] auto

        [time-0000] 10px
        [time-0005] 20px
        [time-0010] 20px
        [time-0015] 20px
        [time-0020] 20px
        [time-0025] 20px
        [time-0030] 10px
        [time-0035] 20px
        [time-0040] 20px
        [time-0045] 20px
        [time-0050] 20px
        [time-0055] 20px

        [time-0100] 10px
        [time-0105] 20px
        [time-0110] 20px
        [time-0115] 20px
        [time-0120] 20px
        [time-0125] 20px
        [time-0130] 10px
        [time-0135] 20px
        [time-0140] 20px
        [time-0145] 20px
        [time-0150] 20px
        [time-0155] 20px

        [time-0200] 10px
        [time-0205] 20px
        [time-0210] 20px
        [time-0215] 20px
        [time-0220] 20px
        [time-0225] 20px
        [time-0230] 10px
        [time-0235] 20px
        [time-0240] 20px
        [time-0245] 20px
        [time-0250] 20px
        [time-0255] 20px

        [time-0300] 10px
        [time-0305] 20px
        [time-0310] 20px
        [time-0315] 20px
        [time-0320] 20px
        [time-0325] 20px
        [time-0330] 10px
        [time-0335] 20px
        [time-0340] 20px
        [time-0345] 20px
        [time-0350] 20px
        [time-0355] 20px

        [time-0400] 10px
        [time-0405] 20px
        [time-0410] 20px
        [time-0415] 20px
        [time-0420] 20px
        [time-0425] 20px
        [time-0430] 10px
        [time-0435] 20px
        [time-0440] 20px
        [time-0445] 20px
        [time-0450] 20px
        [time-0455] 20px

        [time-0500] 10px
        [time-0505] 20px
        [time-0510] 20px
        [time-0515] 20px
        [time-0520] 20px
        [time-0525] 20px
        [time-0530] 10px
        [time-0535] 20px
        [time-0540] 20px
        [time-0545] 20px
        [time-0550] 20px
        [time-0555] 20px

        [time-0600] 10px
        ;

            /* Note 1:
            Use 24hr time for gridline names for simplicity

            Note 2: Use "auto" instead of "1fr" for a more compact schedule where height of a slot is not proportional to the session length. Implementing a "compact" shortcode attribute might make sense for this!
            Try 0.5fr for more compact equal rows. I don't quite understand how that works :)
            */

            grid-template-columns:
        [times] 4em
        [track-1-start] .5fr
        [track-1-end track-2-start] .5fr
        [track-2-end track-3-start] .5fr
        [track-3-end track-4-start] .5fr
        [track-4-end];
    }
    .morning {
            display: grid;
            /*grid-gap: 1em;*/
            grid-template-rows:
        [tracks] auto

        [time-0600] 10px
        [time-0605] 20px
        [time-0610] 20px
        [time-0615] 20px
        [time-0620] 20px
        [time-0625] 20px
        [time-0630] 10px
        [time-0635] 20px
        [time-0640] 20px
        [time-0645] 20px
        [time-0650] 20px
        [time-0655] 20px

        [time-0700] 10px
        [time-0705] 20px
        [time-0710] 20px
        [time-0715] 20px
        [time-0720] 20px
        [time-0725] 20px
        [time-0730] 10px
        [time-0735] 20px
        [time-0740] 20px
        [time-0745] 20px
        [time-0750] 20px
        [time-0755] 20px

        [time-0800] 10px
        [time-0805] 20px
        [time-0810] 20px
        [time-0815] 20px
        [time-0820] 20px
        [time-0825] 20px
        [time-0830] 10px
        [time-0835] 20px
        [time-0840] 20px
        [time-0845] 20px
        [time-0850] 20px
        [time-0855] 20px

        [time-0900] 10px
        [time-0905] 20px
        [time-0910] 20px
        [time-0915] 20px
        [time-0920] 20px
        [time-0925] 20px
        [time-0930] 10px
        [time-0935] 20px
        [time-0940] 20px
        [time-0945] 20px
        [time-0950] 20px
        [time-0955] 20px

        [time-1000] 10px
        [time-1005] 20px
        [time-1010] 20px
        [time-1015] 20px
        [time-1020] 20px
        [time-1025] 20px
        [time-1030] 10px
        [time-1035] 20px
        [time-1040] 20px
        [time-1045] 20px
        [time-1050] 20px
        [time-1055] 20px

        [time-1100] 10px
        [time-1105] 20px
        [time-1110] 20px
        [time-1115] 20px
        [time-1120] 20px
        [time-1125] 20px
        [time-1130] 10px
        [time-1135] 20px
        [time-1140] 20px
        [time-1145] 20px
        [time-1150] 20px
        [time-1155] 20px

        [time-1200] 10px
        ;

            /* Note 1:
            Use 24hr time for gridline names for simplicity

            Note 2: Use "auto" instead of "1fr" for a more compact schedule where height of a slot is not proportional to the session length. Implementing a "compact" shortcode attribute might make sense for this!
            Try 0.5fr for more compact equal rows. I don't quite understand how that works :)
            */

            grid-template-columns:
        [times] 4em
        [track-1-start] .5fr
        [track-1-end track-2-start] .5fr
        [track-2-end track-3-start] .5fr
        [track-3-end track-4-start] .5fr
        [track-4-end];
    }
    .afternoon {
            display: grid;
            /*grid-gap: 1em;*/
            grid-template-rows:
        [tracks] auto

        [time-1200] 10px
        [time-1205] 20px
        [time-1210] 20px
        [time-1215] 20px
        [time-1220] 20px
        [time-1225] 20px
        [time-1230] 10px
        [time-1235] 20px
        [time-1240] 20px
        [time-1245] 20px
        [time-1250] 20px
        [time-1255] 20px

        [time-1300] 10px
        [time-1305] 20px
        [time-1310] 20px
        [time-1315] 20px
        [time-1320] 20px
        [time-1325] 20px
        [time-1330] 10px
        [time-1335] 20px
        [time-1340] 20px
        [time-1345] 20px
        [time-1350] 20px
        [time-1355] 20px

        [time-1400] 10px
        [time-1405] 20px
        [time-1410] 20px
        [time-1415] 20px
        [time-1420] 20px
        [time-1425] 20px
        [time-1430] 10px
        [time-1435] 20px
        [time-1440] 20px
        [time-1445] 20px
        [time-1450] 20px
        [time-1455] 20px

        [time-1500] 10px
        [time-1505] 20px
        [time-1510] 20px
        [time-1515] 20px
        [time-1520] 20px
        [time-1525] 20px
        [time-1530] 10px
        [time-1535] 20px
        [time-1540] 20px
        [time-1545] 20px
        [time-1550] 20px
        [time-1555] 20px

        [time-1600] 10px
        [time-1605] 20px
        [time-1610] 20px
        [time-1615] 20px
        [time-1620] 20px
        [time-1625] 20px
        [time-1630] 10px
        [time-1635] 20px
        [time-1640] 20px
        [time-1645] 20px
        [time-1650] 20px
        [time-1655] 20px

        [time-1700] 10px
        [time-1705] 20px
        [time-1710] 20px
        [time-1715] 20px
        [time-1720] 5px
        [time-1725] 5px
        [time-1730] 10px
        [time-1735] 20px
        [time-1740] 20px
        [time-1745] 20px
        [time-1750] 20px
        [time-1755] 20px

        [time-1800] 10px
        ;

            /* Note 1:
            Use 24hr time for gridline names for simplicity

            Note 2: Use "auto" instead of "1fr" for a more compact schedule where height of a slot is not proportional to the session length. Implementing a "compact" shortcode attribute might make sense for this!
            Try 0.5fr for more compact equal rows. I don't quite understand how that works :)
            */

            grid-template-columns:
        [times] 4em
        [track-1-start] .5fr
        [track-1-end track-2-start] .5fr
        [track-2-end track-3-start] .5fr
        [track-3-end track-4-start] .5fr
        [track-4-end];
    }
    .evening {
        display: grid;
        /*grid-gap: 1em;*/
        grid-template-rows:
        [tracks] auto

        /*[time-1800] 10px
        [time-1805] 20px
        [time-1810] 20px
        [time-1815] 20px
        [time-1820] 20px
        [time-1825] 20px
        [time-1830] 10px
        [time-1835] 20px
        [time-1840] 20px
        [time-1845] 20px
        [time-1850] 20px
        [time-1855] 20px*/

        [time-1900] 10px
        [time-1905] 20px
        [time-1910] 20px
        [time-1915] 20px
        [time-1920] 20px
        [time-1925] 20px
        [time-1930] 10px
        [time-1935] 20px
        [time-1940] 20px
        [time-1945] 20px
        [time-1950] 20px
        [time-1955] 20px

        [time-2000] 10px
        [time-2005] 20px
        [time-2010] 20px
        [time-2015] 20px
        [time-2020] 20px
        [time-2025] 20px
        [time-2030] 10px
        [time-2035] 20px
        [time-2040] 20px
        [time-2045] 20px
        [time-2050] 20px
        [time-2055] 20px

        [time-2100] 10px
        [time-2105] 20px
        [time-2110] 20px
        [time-2115] 20px
        [time-2120] 20px
        [time-2125] 20px
        [time-2130] 10px
        [time-2135] 20px
        [time-2140] 20px
        [time-2145] 20px
        [time-2150] 20px
        [time-2155] 20px

        [time-2200] 10px
        [time-2205] 20px
        [time-2210] 20px
        [time-2215] 20px
        [time-2220] 20px
        [time-2225] 20px
        [time-2230] 10px
        [time-2235] 20px
        [time-2240] 20px
        [time-2245] 20px
        [time-2250] 20px
        [time-2255] 20px

        [time-2300] 10px
        /*[time-2305] 20px
        [time-2310] 20px
        [time-2315] 20px
        [time-2320] 20px
        [time-2325] 20px
        [time-2330] 10px
        [time-2335] 20px
        [time-2340] 20px
        [time-2345] 20px
        [time-2350] 20px
        [time-2355] 20px
        [time-2400] 10px*/
    ;

        /* Note 1:
        Use 24hr time for gridline names for simplicity

        Note 2: Use "auto" instead of "1fr" for a more compact schedule where height of a slot is not proportional to the session length. Implementing a "compact" shortcode attribute might make sense for this!
        Try 0.5fr for more compact equal rows. I don't quite understand how that works :)
        */

        grid-template-columns:
        [times] 4em
        [track-1-start] .5fr
        [track-1-end track-2-start] .5fr
        [track-2-end track-3-start] .5fr
        [track-3-end track-4-start] .5fr
        [track-4-end];
    }
    .schedule {
        display: grid;
        /*grid-gap: .6em;*/
        grid-template-rows:
        [tracks] auto
        [time-0000] 10px
        [time-0005] 20px
        [time-0010] 20px
        [time-0015] 20px
        [time-0020] 20px
        [time-0025] 20px
        [time-0030] 10px
        [time-0035] 20px
        [time-0040] 20px
        [time-0045] 20px
        [time-0050] 20px
        [time-0055] 20px

        [time-0100] 10px
        [time-0105] 20px
        [time-0110] 20px
        [time-0115] 20px
        [time-0120] 20px
        [time-0125] 20px
        [time-0130] 10px
        [time-0135] 20px
        [time-0140] 20px
        [time-0145] 20px
        [time-0150] 20px
        [time-0155] 20px

        [time-0200] 10px
        [time-0205] 20px
        [time-0210] 20px
        [time-0215] 20px
        [time-0220] 20px
        [time-0225] 20px
        [time-0230] 10px
        [time-0235] 20px
        [time-0240] 20px
        [time-0245] 20px
        [time-0250] 20px
        [time-0255] 20px

        [time-0300] 10px
        [time-0305] 20px
        [time-0310] 20px
        [time-0315] 20px
        [time-0320] 20px
        [time-0325] 20px
        [time-0330] 10px
        [time-0335] 20px
        [time-0340] 20px
        [time-0345] 20px
        [time-0350] 20px
        [time-0355] 20px

        [time-0400] 10px
        [time-0405] 20px
        [time-0410] 20px
        [time-0415] 20px
        [time-0420] 20px
        [time-0425] 20px
        [time-0430] 10px
        [time-0435] 20px
        [time-0440] 20px
        [time-0445] 20px
        [time-0450] 20px
        [time-0455] 20px

        [time-0500] 10px
        [time-0505] 20px
        [time-0510] 20px
        [time-0515] 20px
        [time-0520] 20px
        [time-0525] 20px
        [time-0530] 10px
        [time-0535] 20px
        [time-0540] 20px
        [time-0545] 20px
        [time-0550] 20px
        [time-0555] 20px

        [time-0600] 10px
        [time-0605] 20px
        [time-0610] 20px
        [time-0615] 20px
        [time-0620] 20px
        [time-0625] 20px
        [time-0630] 10px
        [time-0635] 20px
        [time-0640] 20px
        [time-0645] 20px
        [time-0650] 20px
        [time-0655] 20px

        [time-0700] 10px
        [time-0705] 20px
        [time-0710] 20px
        [time-0715] 20px
        [time-0720] 20px
        [time-0725] 20px
        [time-0730] 10px
        [time-0735] 20px
        [time-0740] 20px
        [time-0745] 20px
        [time-0750] 20px
        [time-0755] 20px

        [time-0800] 10px
        [time-0805] 20px
        [time-0810] 20px
        [time-0815] 20px
        [time-0820] 20px
        [time-0825] 20px
        [time-0830] 10px
        [time-0835] 20px
        [time-0840] 20px
        [time-0845] 20px
        [time-0850] 20px
        [time-0855] 20px

        [time-0900] 10px
        [time-0905] 20px
        [time-0910] 20px
        [time-0915] 20px
        [time-0920] 20px
        [time-0925] 20px
        [time-0930] 10px
        [time-0935] 20px
        [time-0940] 20px
        [time-0945] 20px
        [time-0950] 20px
        [time-0955] 20px

        [time-1000] 10px
        [time-1005] 20px
        [time-1010] 20px
        [time-1015] 20px
        [time-1020] 20px
        [time-1025] 20px
        [time-1030] 10px
        [time-1035] 20px
        [time-1040] 20px
        [time-1045] 20px
        [time-1050] 20px
        [time-1055] 20px

        [time-1100] 10px
        [time-1105] 20px
        [time-1110] 20px
        [time-1115] 20px
        [time-1120] 20px
        [time-1125] 20px
        [time-1130] 10px
        [time-1135] 20px
        [time-1140] 20px
        [time-1145] 20px
        [time-1150] 20px
        [time-1155] 20px

        [time-1200] 10px
        [time-1205] 20px
        [time-1210] 20px
        [time-1215] 20px
        [time-1220] 20px
        [time-1225] 20px
        [time-1230] 10px
        [time-1235] 20px
        [time-1240] 20px
        [time-1245] 20px
        [time-1250] 20px
        [time-1255] 20px

        [time-1300] 10px
        [time-1305] 20px
        [time-1310] 20px
        [time-1315] 20px
        [time-1320] 20px
        [time-1325] 20px
        [time-1330] 10px
        [time-1335] 20px
        [time-1340] 20px
        [time-1345] 20px
        [time-1350] 20px
        [time-1355] 20px

        [time-1400] 10px
        [time-1405] 20px
        [time-1410] 20px
        [time-1415] 20px
        [time-1420] 20px
        [time-1425] 20px
        [time-1430] 10px
        [time-1435] 20px
        [time-1440] 20px
        [time-1445] 20px
        [time-1450] 20px
        [time-1455] 20px

        [time-1500] 10px
        [time-1505] 20px
        [time-1510] 20px
        [time-1515] 20px
        [time-1520] 20px
        [time-1525] 20px
        [time-1530] 10px
        [time-1535] 20px
        [time-1540] 20px
        [time-1545] 20px
        [time-1550] 20px
        [time-1555] 20px

        [time-1600] 10px
        [time-1605] 20px
        [time-1610] 20px
        [time-1615] 20px
        [time-1620] 20px
        [time-1625] 20px
        [time-1630] 10px
        [time-1635] 20px
        [time-1640] 20px
        [time-1645] 20px
        [time-1650] 20px
        [time-1655] 20px

        [time-1700] 10px
        [time-1705] 20px
        [time-1710] 20px
        [time-1715] 20px
        [time-1720] 5px
        [time-1725] 5px
        [time-1730] 10px
        [time-1735] 20px
        [time-1740] 20px
        [time-1745] 20px
        [time-1750] 20px
        [time-1755] 20px

        [time-1800] 10px
        [time-1805] 20px
        [time-1810] 20px
        [time-1815] 20px
        [time-1820] 20px
        [time-1825] 20px
        [time-1830] 10px
        [time-1835] 20px
        [time-1840] 20px
        [time-1845] 20px
        [time-1850] 20px
        [time-1855] 20px

        [time-1900] 10px
        [time-1905] 20px
        [time-1910] 20px
        [time-1915] 20px
        [time-1920] 20px
        [time-1925] 20px
        [time-1930] 10px
        [time-1935] 20px
        [time-1940] 20px
        [time-1945] 20px
        [time-1950] 20px
        [time-1955] 20px

        [time-2000] 10px
        [time-2005] 20px
        [time-2010] 20px
        [time-2015] 20px
        [time-2020] 20px
        [time-2025] 20px
        [time-2030] 10px
        [time-2035] 20px
        [time-2040] 20px
        [time-2045] 20px
        [time-2050] 20px
        [time-2055] 20px

        [time-2100] 10px
        [time-2105] 20px
        [time-2110] 20px
        [time-2115] 20px
        [time-2120] 20px
        [time-2125] 20px
        [time-2130] 10px
        [time-2135] 20px
        [time-2140] 20px
        [time-2145] 20px
        [time-2150] 20px
        [time-2155] 20px

        [time-2200] 10px
        [time-2205] 20px
        [time-2210] 20px
        [time-2215] 20px
        [time-2220] 20px
        [time-2225] 20px
        [time-2230] 10px
        [time-2235] 20px
        [time-2240] 20px
        [time-2245] 20px
        [time-2250] 20px
        [time-2255] 20px

        [time-2300] 10px
        [time-2305] 20px
        [time-2310] 20px
        [time-2315] 20px
        [time-2320] 20px
        [time-2325] 20px
        [time-2330] 10px
        [time-2335] 20px
        [time-2340] 20px
        [time-2345] 20px
        [time-2350] 20px
        [time-2355] 20px

        [time-2400] 10px
        [time-2405] 20px
        [time-2410] 20px
        [time-2415] 20px
      /*  [time-2420] 20px
        [time-2425] 20px
        [time-2430] 10px
        [time-2435] 20px
      [time-2440] 20px
      [time-2445] 20px
      [time-2450] 20px
      [time-2455] 20px

      [time-2500] 10px
      [time-2505] 20px
      [time-2510] 20px
      [time-2515] 20px
      [time-2520] 20px
      [time-2525] 20px
      [time-2530] 10px
      [time-2535] 20px
      [time-2540] 20px
      [time-2545] 20px
      [time-2550] 20px
      [time-2555] 20px*/
    ;

        /* Note 1:
        Use 24hr time for gridline names for simplicity

        Note 2: Use "auto" instead of "1fr" for a more compact schedule where height of a slot is not proportional to the session length. Implementing a "compact" shortcode attribute might make sense for this!
        Try 0.5fr for more compact equal rows. I don't quite understand how that works :)
        */

        grid-template-columns:
        [times] 4em
        [track-1-start] .5fr
        [track-1-end track-2-start] .5fr
        [track-2-end track-3-start] .5fr
        [track-3-end track-4-start] .5fr
        [track-4-end];
    }
}


.track-slot {
    /*display: none;*/ /* hidden on small screens and browsers without grid support */
    display: block;
    padding: 0;
    top: 101px;
    height: 40px;
    z-index: 1000;
    background-color: rgba(255,255,255,.9);
}

@supports( display:grid ) {
    @media screen and (min-width:700px) {
        .track-slot {
            display: block;
            padding: 0;
            position: sticky;
            top: 90px;
            z-index: 1000;
            background-color: rgba(255,255,255,.9);
        }
    }
}

/* Small-screen & fallback styles */
.session {
    margin-bottom:  .5em;
}
.session:hover{
    cursor: pointer;
}

@supports( display:grid ) {
    @media screen and (min-width: 700px) {
        .session {
            margin: 0;
        }
    }
}

/*************************
 * VISUAL STYLES
 * Design-y stuff ot particularly important to the demo
 *************************/
body {
    padding: 10px;
    max-width: 1100px;
    margin: 0 auto;
    /*line-height: 1.5;*/
}

.session {
    /*padding: .5em;
    border-radius: 2px;*/
    font-size: 20px;
    line-height: 20px;
    min-height: 35px;

    /*box-shadow:
            rgba(255,255,255,.6) 1px 1px 0,
            rgba(0,0,0,.3) 4px 4px 0;*/
}

.session-title,
.session-time,
.session-track,
.session-presenter {
    display: block;
}

.session-title,
.time-slot {
    display: none;
    color: black;
    text-transform: lowercase;
    font-family: Avenir-medium;
}

@supports( display:grid ) {
    @media screen and (min-width:700px) {
        .time-slot {
            /*margin: 6px 0 0 0;
            font-size: 1em;
            line-height: 5px;
            display: block;
            min-width: 90px;*/

          margin: 6px 20px 0 0;
          font-size: 1em;
          line-height: 8px;
          display: block;
          min-width: 105px;
          margin-left: -40px;
          padding-right: 5px;
          text-align: right;
          font-family: Avenir-medium;

        }
        .size-24 {
            font-size: 16px;
            line-height: 22px;
        }
    }
}

.session-title a {
    color: #fff;
    text-decoration-style: dotted;

&:hover {
     font-style: italic;
 }

&:focus {
     outline: 2px dotted rgba(255,255,255,.8);
 }
}

.track-slot {
    font-weight: bold;
    font-size:.75em;
}

/* #c35500 / #544D69 / #e2bc00/ #687f00 */
/* #02abba / #687f00 / #012c58 / #dedede or #de011b */
.track-1 {
    /*background-color: #02abba;*/
    /*color: #fff;*/
  color: black;
  border: 1px solid #777;
  border-left: 2px solid #777;
}
.track-1:hover {
    background-color: #f2f1f1;
    color: #fff;
}
.track-1-title{
    color: #02abba;
  margin-bottom: 30px;
  top: 200px;
  position: sticky;
}



.track-2 {
    /*background-color: #f15a21e8;*/
    /*color: #fff;*/
  color: black;
  border: 1px solid #777;
}
.track-2:hover {
    background-color: #f2f1f1;
    color: #fff;
}
.track-2-title{
  color: #9cc639;
  top: 200px;
  position: sticky;
}

.track-3 {
    /*background-color: #012c58;*/
    /*color: #fff;*/
  color: black;
  border: 1px solid #777;
}
.track-3:hover {
    background-color: #f2f1f1;
    color: #fff;
}
.track-3-title{
  color: #012c58;
  top: 200px;
  position: sticky;
}

.track-4 {
    /*background-color: #6f6e6e;*/
    /*color: #fff;*/
  color: black;
  border: 1px solid #777;
  border-right: 2px solid #777;
}
.track-4:hover {
    background-color: #f2f1f1;
    color: #fff;
}
.track-4-title{
  color: #6f6e6e;
  top: 200px;
  position: sticky;
}

.track-all {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ccc;
    color: #777;
    box-shadow: none;
}

.text {
    max-width: 750px;
    font-size: 18px;
    margin: 0 auto 10px;
}

.meta {
    color: #555;
    font-style: italic;
}

.meta a {
    color: #555;
}

hr {
    margin: 10px 0;
}
strong{
  font-size: 22px;
  line-height: 22px;
  margin-top:4px;
}
.show_details_content{
   /* line-height: 25px;*/
    margin-top: 5px;
    margin-bottom: 5px;
    padding-left: 10px;
    padding-right: 10px;
    color:#01aeb4;
    /*font-size: 1.6vh;*/
    /*font-size: min(20px, 1.6vh);*/
    font-size: 20px;
    background-color:transparent;
}
</style>